$(document).ready(function () {
  const SELECTORS = {
    FORM: "#cart-page-form",
    QTY_INPUT: ".js-qty__num",
    QTY_ADJUST: ".js-qty__adjust",
    QTY_PLUS: ".js-qty__adjust--plus",
    ERROR: ".cart__error",
    CART_COUNT: ".header-bar__cart-count",
    ORIGINAL_PRICE: "[data-item-original-price]",
    LINE_PRICE: "[data-item-line-price]",
    CART_TOTAL: ".cart__subtotal",
  };

  const LIMITS = {
    MIN_QTY: 1,
    MAX_QTY: 100,
    MIN_CHAR_CODE: 48,
    MAX_CHAR_CODE: 57,
  };

  const ENDPOINTS = {
    CART_CHANGE: "/cart/change.js",
    CART_GET: "/cart.js",
  };

  const isDe = Shopify.locale === "de";

  const CartManager = {
    async updateQuantity(itemKey, quantity) {
      try {
        const response = await fetch(`${isDe ? "/de" : ""}${ENDPOINTS.CART_CHANGE}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: itemKey, quantity }),
        });
        return await response.json();
      } catch (error) {
        console.error("Failed to update cart:", error);
        throw error;
      }
    },

    async getCart() {
      try {
        const response = await fetch(`${isDe ? "/de" : ""}${ENDPOINTS.CART_GET}`);
        return await response.json();
      } catch (error) {
        console.error("Failed to get cart:", error);
        throw error;
      }
    },
  };

  const UIManager = {
    updatePrices($container, cart, itemKey) {
      const item = cart.items.find((item) => item.key === itemKey);
      
      if (!item) return;

      const currencySymbol = this.getCurrencySymbol($container);
      const $cartCount = $(SELECTORS.CART_COUNT);
      const $row = $container.find(`tr[data-line="${itemKey}"]`);

      $cartCount.text(cart.item_count);
      this.updateElement(
        $row,
        SELECTORS.ORIGINAL_PRICE,
        formatPrice(item.original_line_price, currencySymbol)
      );
      this.updateElement($row, SELECTORS.LINE_PRICE, formatPrice(item.line_price, currencySymbol));

      const $form = $container.closest(SELECTORS.FORM);
      this.updateElement(
        $form,
        SELECTORS.CART_TOTAL,
        formatPrice(cart.total_price, currencySymbol)
      );
    },

    updateElement($container, selector, value) {
      const $element = $container.find(selector);
      if ($element.length) {
        $element.text(value);
      }
    },

    getCurrencySymbol($container) {
      return $container.find(SELECTORS.LINE_PRICE).text().trim()[0];
    },

    showError($container, message) {
      $container.find(SELECTORS.ERROR).text(message);
    },

    clearError($container) {
      $container.find(SELECTORS.ERROR).text("");
    },
  };

  const debouncedOnQtyChange = debounce(async function (e, quantity) {
    try {
      const $row = $(e.target).closest("tr");
      const itemKey = $row.attr("data-line");
      const cart = await CartManager.updateQuantity(itemKey, quantity);
      UIManager.clearError($(SELECTORS.FORM));
      if (!cart.ok) {
        await handleError(e, cart, itemKey);
        return;
      }
      UIManager.updatePrices($row, cart, itemKey);
    } catch (error) {
      UIManager.showError($(SELECTORS.FORM), "Failed to update cart. Please try again.");
    }
  }, 200);

  async function handleError(e, cart, itemKey) {
    const $form = $(SELECTORS.FORM);
    UIManager.showError($form, cart.message);

    try {
      const newCart = await CartManager.getCart();
      UIManager.updatePrices($form, newCart, itemKey);

      const $input = $(e.target).closest("tr").find(SELECTORS.QTY_INPUT);
      const newQuantity = newCart.items.find((item) => item.key === itemKey)?.quantity;
      if (newQuantity) {
        $input.val(newQuantity);
      }
    } catch (error) {
      console.error("Failed to handle error:", error);
    }
  }

  function formatPrice(price, currency) {
    return `${currency}${(price / 100).toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  $(SELECTORS.FORM).on("blur", SELECTORS.QTY_INPUT, function (e) {
    debouncedOnQtyChange(e, $(this).val());
  });

  $(SELECTORS.FORM).on("click", SELECTORS.QTY_ADJUST, function (e) {
    const $input = $(this).siblings(SELECTORS.QTY_INPUT);
    let quantity = parseInt($input.val().replace(/\D/g, ""));

    quantity = $(this).hasClass(SELECTORS.QTY_PLUS.slice(1))
      ? quantity + 1
      : Math.max(LIMITS.MIN_QTY, quantity - 1);

    $input.val(quantity);
    debouncedOnQtyChange(e, quantity);
  });

  $(SELECTORS.FORM).on("keypress", SELECTORS.QTY_INPUT, function (e) {
    if (e.charCode < LIMITS.MIN_CHAR_CODE || e.charCode > LIMITS.MAX_CHAR_CODE) {
      e.preventDefault();
      return false;
    }

    const newValue =
      this.value.substring(0, this.selectionStart) +
      String.fromCharCode(e.charCode) +
      this.value.substring(this.selectionEnd);

    if (parseInt(newValue) > LIMITS.MAX_QTY) {
      e.preventDefault();
      return false;
    }
  });
});
